// ==================== INDUSTRY BENCHMARK DATA ====================

export const INDUSTRY_BENCHMARKS = {
  healthcare: {
    digitalMaturity: {
      industryAverage: 2.8,
      leaders: 4.5,
      laggards: 1.5,
      yourBaseline: 2.0
    },
    performanceMetrics: {
      patientSatisfaction: { industry: '75%', best: '92%', target: '90%' },
      operationalEfficiency: { industry: '65%', best: '88%', target: '85%' },
      costPerPatient: { industry: '$1,200', best: '$700', target: '$800' },
      readmissionRate: { industry: '15%', best: '5%', target: '7%' }
    },
    aiAdoption: {
      industryAverage: '35%',
      leaders: '70%',
      expectedGrowth: '+25% YoY'
    }
  },
  finance: {
    digitalMaturity: {
      industryAverage: 3.2,
      leaders: 4.8,
      laggards: 2.0,
      yourBaseline: 2.5
    },
    performanceMetrics: {
      costToIncome: { industry: '55%', best: '35%', target: '40%' },
      fraudDetectionRate: { industry: '85%', best: '99%', target: '98%' },
      customerRetention: { industry: '80%', best: '95%', target: '92%' },
      roa: { industry: '1.0%', best: '2.5%', target: '2.0%' }
    },
    aiAdoption: {
      industryAverage: '45%',
      leaders: '80%',
      expectedGrowth: '+30% YoY'
    }
  },
  ecommerce: {
    digitalMaturity: {
      industryAverage: 3.5,
      leaders: 4.7,
      laggards: 2.2,
      yourBaseline: 2.8
    },
    performanceMetrics: {
      conversionRate: { industry: '2.5%', best: '5%', target: '4%' },
      cartAbandonment: { industry: '70%', best: '50%', target: '55%' },
      customerLifetimeValue: { industry: '$150', best: '$400', target: '$300' },
      inventoryTurnover: { industry: '6x', best: '12x', target: '10x' }
    },
    aiAdoption: {
      industryAverage: '50%',
      leaders: '85%',
      expectedGrowth: '+35% YoY'
    }
  },
  manufacturing: {
    digitalMaturity: {
      industryAverage: 2.5,
      leaders: 4.3,
      laggards: 1.3,
      yourBaseline: 1.8
    },
    performanceMetrics: {
      oee: { industry: '65%', best: '85%', target: '80%' },
      firstPassYield: { industry: '90%', best: '99%', target: '97%' },
      downtime: { industry: '15%', best: '3%', target: '5%' },
      energyEfficiency: { industry: '70%', best: '90%', target: '85%' }
    },
    aiAdoption: {
      industryAverage: '30%',
      leaders: '65%',
      expectedGrowth: '+28% YoY'
    }
  },
  general: {
    digitalMaturity: {
      industryAverage: 2.5,
      leaders: 4.2,
      laggards: 1.2,
      yourBaseline: 1.8
    },
    performanceMetrics: {
      operationalEfficiency: { industry: '60%', best: '85%', target: '80%' },
      customerSatisfaction: { industry: '70%', best: '90%', target: '85%' },
      costReduction: { industry: '5%', best: '25%', target: '20%' },
      innovationRate: { industry: '10%', best: '35%', target: '30%' }
    },
    aiAdoption: {
      industryAverage: '30%',
      leaders: '65%',
      expectedGrowth: '+25% YoY'
    }
  }
};

export const PEER_COMPARISON = {
  quartiles: {
    topQuartile: {
      name: 'Leaders',
      characteristics: ['AI embedded in strategy', 'Strong data governance', 'Automated ML pipelines'],
      performance: '2-3x better than average',
      aiMaturity: 4.0
    },
    secondQuartile: {
      name: 'Fast Followers',
      characteristics: ['Active AI programs', 'Dedicated teams', 'Pilot projects running'],
      performance: '1.5-2x better than average',
      aiMaturity: 3.0
    },
    thirdQuartile: {
      name: 'Explorers',
      characteristics: ['Initial AI experiments', 'Building capabilities', 'Learning phase'],
      performance: 'Slightly above average',
      aiMaturity: 2.0
    },
    bottomQuartile: {
      name: 'Laggards',
      characteristics: ['No AI strategy', 'Limited capabilities', 'Reactive approach'],
      performance: 'Below average',
      aiMaturity: 1.0
    }
  }
};

export const BEST_IN_CLASS_TARGETS = {
  efficiency: {
    processAutomation: '70%+',
    cycleTimeReduction: '50%+',
    costReduction: '30%+',
    resourceUtilization: '85%+'
  },
  quality: {
    defectRate: '< 0.5%',
    accuracy: '> 95%',
    customerSatisfaction: '> 90%',
    firstTimeRight: '> 92%'
  },
  speed: {
    timeToMarket: '< 3 months',
    deploymentFrequency: 'Daily',
    responseTime: '< 1 second',
    decisionLatency: 'Real-time'
  },
  innovation: {
    useCasesPerYear: '20+',
    rndEffectiveness: '35%+',
    patentFilings: '10+',
    newRevenueStreams: '3+'
  }
};